// Runtime configuration, served as /config.json next to the app so one image serves every
// instance (ADR-0012). Values are public (no secrets).
export type AppConfig = {
  oidcIssuer: string
  oidcClientId: string
  /** Rollout switch for the estimator screens; the API has its own switch and enforces it.
   * Caddy serves it as the string "true"/"false"; anything but true is off. */
  estimatorEnabled?: boolean | string
}

export function isEstimatorEnabled(config: AppConfig): boolean {
  return config.estimatorEnabled === true || config.estimatorEnabled === "true"
}

export async function loadConfig(fetcher: typeof fetch = fetch): Promise<AppConfig> {
  const response = await fetcher("/config.json", { cache: "no-store" })
  if (!response.ok) throw new Error("configuration unavailable")
  return (await response.json()) as AppConfig
}

let estimator = false

/** Set once at start-up from the runtime configuration. */
export function setEstimatorEnabled(enabled: boolean): void {
  estimator = enabled
}

export function estimatorEnabled(): boolean {
  return estimator
}
